import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import withDidMountRequest from 'app/connectors/withDidMountRequest'
import { processReportsQuery } from 'store/entities/reviews/actions'
import { getReviewsReportData, isReviewsReportPending } from 'store/entities/reviews/selectors'

import Reports from './Reports'

const mapStateToProps = createStructuredSelector({
  report: getReviewsReportData,
  isPending: isReviewsReportPending,
})

const mapDispatchToProps = {
  onRequest: processReportsQuery,
}

export default connect(mapStateToProps, mapDispatchToProps)(withDidMountRequest(Reports))
